// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__6PNUC","tooltipError":"Tooltip_tooltipError__mgMn7"};